module.exports = __webpack_public_path__ + "img/pdf_preview_gastro_de.19e8b477.png";